<input
  type="checkbox"
  class="toggle"
  [attr.id]="fieldId"
  [attr.data-e2e-id]="toggleInputE2eId"
  [formControl]="fieldControl"
/>

<label
  class="toggle-btn"
  tabindex="0"
  [attr.for]="fieldId"
  [attr.data-e2e-id]="toggleLabelE2eId"
  (click)="toggleClick.emit($event)"
>
</label>
